import React, { useState, useEffect } from "react";
import styled from "styled-components";
import GridMediaCard from "components/MediaLibrary/GridMediaCard/GridMediaCard";
import { StockImage } from "api/media-library";
import _ from "lodash";
import { SkedIcon } from "../../../../ui";

type Props = {
  images: StockImage[];
  selectedImages: StockImage[];
  onChange: (images: StockImage[]) => void;
};

const StockImagesGrid = ({ images, selectedImages, onChange }: Props) => {
  const [selectedCardIds, setSelectedCardIds] = useState<number[]>([]);

  useEffect(() => {
    setSelectedCardIds(selectedImages.map((image) => image.id));
  }, [selectedImages]);

  const toggleSelection = (selectedId: number) => {
    const newIdsArray = [...selectedCardIds];
    if (selectedCardIds.includes(selectedId)) {
      _.pull(newIdsArray, selectedId);
    } else {
      newIdsArray.push(selectedId);
    }
    setSelectedCardIds(newIdsArray);
    onChange(images.filter((image) => newIdsArray.includes(image.id)));
  };
  const getHoverProps = (media: object) => {
    return (
      <div className="flex flex-col">
        <div className="flex pt-4 pl-4 pr-4 pb-2 h-full items-center cursor-default">
          <div className="flex flex-wrap">
            <div className="flex text-lg">By {media.photographer}</div>
          </div>
          <div className="flex-grow flex justify-end font-black">
            <div className="mr-4 leading-none">
              <a href={media.url} target="_blank" rel="noopener noreferrer">
                <SkedIcon
                  icon="icon-crop-2"
                  color="purple"
                  size="14"
                  tooltip="View on Pexels"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Grid>
      {images.map((image) => {
        const isSelected = selectedCardIds.includes(image.id);
        return (
          <GridMediaCard
            key={image.id}
            id={image.id}
            assetUrl={image.src.medium}
            selected={isSelected}
            selecting={selectedCardIds.length > 0}
            canFavorite={false}
            hoverProps={getHoverProps(image)}
            onCardClick={() => toggleSelection(image.id)}
          />
        );
      })}
    </Grid>
  );
};

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default StockImagesGrid;
